module.exports = __webpack_public_path__ + "media/images/business/transformation-timeline-4eb1ac50c190bcf3f27fbe17922641eb.svg";